import { useTypedTranslations } from '../../../translation/use-translations';
import SportsbookUnavailable from '../../components/sportsbook-unavailable';

enum TextKeys {
	ERROR_MESSAGE_TITLE = 'SPORTSBOOK_API_ERROR_MESSAGE_TITLE',
	ERROR_MESSAGE_DESCRIPTION = 'SPORTSBOOK_API_ERROR_MESSAGE_DESCRIPTION'
}

const SportsbookApiErrorDisplay: React.FC = () => {
	const { isLoadingTranslations, translations } = useTypedTranslations(TextKeys);

	if (isLoadingTranslations) {
		return null;
	}

	return (
		<SportsbookUnavailable
			title={translations[TextKeys.ERROR_MESSAGE_TITLE]}
			description={translations[TextKeys.ERROR_MESSAGE_DESCRIPTION]}
		/>
	);
};

export default SportsbookApiErrorDisplay;
